import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

import { getFormatDateByLocal } from '../../utils/date-helper';

@Component({
    name: 'DateInputPicker',
    template: require('./date-input-picker-template.html'),
})

export default class DateInputPicker extends Vue {
    @Prop({type: [String, Date], default: () => ''}) value: any;
    @Prop({ default: false})
    disabled: boolean
    @Prop({ default: false}) clearable: boolean;
    
    @Prop({ default: () => {}})
    options: any;

    @Prop({ default: ''})
    inputSize: string;

    dateMask = {
        mask: '99/99/9999'
    };
    dateFormat: string = 'dd/mm/yyyy';
    invalidInput: boolean = false;

    private displayDate: string = null;

    get inputPlaceholder() {
        return this.dateFormat;
    }
    get inputValue() {
        return this.value ? moment(this.value).format(this.dateFormat.toUpperCase()) : this.displayDate;
    }
    set inputValue(newVal) {
        const date = moment(newVal, this.dateFormat.toUpperCase(), true);
        if (date.isValid()) {
            this.emitDateValue(date.toDate());
        } else {
            this.$emit('input', null);
            this.$emit('change', null);
            this.invalidInput = newVal ? true : false;
        }
    }

    get datePickerValue() {
        return this.value
    }
    set datePickerValue(newVal) {
        this.emitDateValue(newVal);
    }

    private isValidOptionCondition(date) {
        if (this.options && this.options.disabledDate) {
            const isDisbledDate = this.options.disabledDate(date);
            if (isDisbledDate) {
                return false;
            }
        }
        return true;
    }
    private isValidDateFormat(value) {
        const date = moment(value, this.dateFormat, true);
        return date.isValid();
    }
    private isValidDate(value) {
        if (!value) return true;
        const isValidOptCondition = this.isValidOptionCondition(value);
        const isValidFormat = this.isValidDateFormat(value);
        return isValidFormat && isValidOptCondition;
    }
    private emitDateValue(newVal) {
        const isValidDate = this.isValidDate(newVal);
        if (!isValidDate) {
            this.invalidInput = true;
            this.$emit('input', null);
            this.$emit('change', null);
            return;
        } else {
            this.invalidInput = false;
            this.$emit('input', newVal);
            this.$emit('change', newVal);
        }
    }

    get pickerOption () {
        //Cause default type is "Date"
        let opts = {...this.options} || {};
        
        if (!opts.shortcuts) [
            opts.shortcuts = [{
                text: this.$t('TODAY'),
                onClick(picker) {
                  picker.$emit('pick', new Date());
                }
            }]
        ]

        opts.firstDayOfWeek = 1;

        return opts;
    }

    checkValidateDate(event) {
        // if (event.target.value) {
        //     const date = moment(event.target.value, this.inputPlaceholder.toUpperCase(), true);
        //     this.invalidInput = !date.isValid() || !this.isValidOptionCondition(date);
        // } else this.invalidInput = false;
        const isValidDate = this.isValidDate(event.target.value);
        if (!isValidDate) {
            this.invalidInput = true;
            this.displayDate = null;
        } else {
            this.invalidInput = false;
        }
    }

    onChangeInputValue(val) {
        console.log('onChangeInputValue: ', val);
        this.displayDate = val;
    }

    clear() {
        this.invalidInput = false;
        this.$emit('input', null);
        this.$emit('change', null);
    }

    mounted() {
        this.dateFormat = getFormatDateByLocal();
        this.dateMask.mask = this.dateFormat.replace(/[YydDmM]/g, '9');
    }
}